const api = window.claraplayer('threekitPlayer', { makeErrorsFatal: true });
window.api = api;
export default api;
